import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/operation_activities',
  component: Management,
  redirect: '/operation_activities/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/operation_activities/List'),
      meta: {
        auth: Auth.listOperationActivities
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/operation_activities/ListTable'),
          meta: {
            auth: Auth.listOperationActivities,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/operation_activities/New'),
      meta: {
        auth: Auth.createOperationActivity
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/operation_activities/Edit'),
      meta: {
        auth: Auth.updateOperationActivity
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/operation_activities/DetailLayout'),
      meta: {
        auth: Auth.showOperationActivity
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/operation_activities/details/Detail'),
          meta: {
            auth: Auth.showOperationActivity,
            tabName: 'detail'
          }
        },
        // 参与记录
        {
          path: 'participations',
          component: () => import('@/views/operation_activities/details/Participations'),
          meta: {
            auth: Auth.showOperationActivity,
            tabName: 'participations'
          }
        }
      ]
    }
  ]
}
